module.exports = __webpack_public_path__ + "src/assets/img/share/tips/open/c7f158111f078b8b666a849da04f4a31.png";